import { deliveryMethods } from './constants'

export const getMenuItems = t => deliveryMethods.map(dm => ({ label: t(dm.label), value: dm.value }))
